

// import React, { useState } from 'react';
// import {
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   AreaChart,
//   Area,
// } from 'recharts';
// import html2pdf from 'html2pdf.js';
// import CalculatorForm from './CalculatorForm';
// import { motion } from 'framer-motion';
// import {
//   FaGraduationCap,
//   FaChartLine,
//   FaBullseye,
//   FaFilePdf,
//   FaWhatsapp,
// } from 'react-icons/fa';

// const ChildEducationCalculator = () => {
//   const [childAge, setChildAge] = useState(5);
//   const [educationAge, setEducationAge] = useState(18);
//   const [currentEducationCost, setCurrentEducationCost] = useState(1000000);
//   const [inflationRate, setInflationRate] = useState(6);
//   const [monthlyInvestment, setMonthlyInvestment] = useState(5000);
//   const [expectedReturn, setExpectedReturn] = useState(12);

//   const [showForm, setShowForm] = useState(false);
//   const [result, setResult] = useState(null);
//   const [chartData, setChartData] = useState([]);

//   const formatCurrency = (amount) => {
//     return `₹${Number(amount).toLocaleString('en-IN')}`;
//   };

//   const calculate = () => {
//     const yearsToEducation = educationAge - childAge;
//     const months = yearsToEducation * 12;

//     const futureCost =
//       currentEducationCost *
//       Math.pow(1 + inflationRate / 100, yearsToEducation);

//     const monthlyRate = expectedReturn / 12 / 100;

//     const futureValueOfSIP =
//       monthlyInvestment *
//       ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) *
//       (1 + monthlyRate);

//     const requiredMonthlySIP =
//       (futureCost * monthlyRate) /
//       ((Math.pow(1 + monthlyRate, months) - 1) *
//         (1 + monthlyRate));

//     const additionalMonthlyNeeded = Math.max(
//       0,
//       requiredMonthlySIP - monthlyInvestment
//     );

//     const fundingGap = Math.max(
//       0,
//       futureCost - futureValueOfSIP
//     );

//     const data = [];

//     for (let year = 1; year <= yearsToEducation; year++) {
//       const costAtYear =
//         currentEducationCost *
//         Math.pow(1 + inflationRate / 100, year);

//       const sipValue =
//         monthlyInvestment *
//         ((Math.pow(
//           1 + monthlyRate,
//           year * 12
//         ) - 1) /
//           monthlyRate) *
//         (1 + monthlyRate);

//       data.push({
//         year,
//         educationCost: Math.round(costAtYear),
//         savingsAmount: Math.round(sipValue),
//       });
//     }

//     const isTargetReached =
//       futureValueOfSIP >= futureCost;

//     const percentageAchieved =
//       (futureValueOfSIP / futureCost) * 100;

//     setResult({
//       futureCost,
//       futureValueOfSIP,
//       requiredMonthlySIP,
//       additionalMonthlyNeeded,
//       fundingGap,
//       isTargetReached,
//       percentageAchieved: Math.min(
//         100,
//         percentageAchieved
//       ),
//       yearsToEducation,
//     });

//     setChartData(data);
//   };

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById(
//       'education-result-content'
//     );

//     const opt = {
//       margin: 0.5,
//       filename: `Child_Education_Report_${userData.name}.pdf`,
//       image: {
//         type: 'jpeg',
//         quality: 0.98,
//       },
//       html2canvas: {
//         scale: 2,
//       },
//       jsPDF: {
//         unit: 'in',
//         format: 'a4',
//         orientation: 'portrait',
//       },
//     };

//     html2pdf()
//       .set(opt)
//       .from(element)
//       .save();

//     setShowForm(false);

//     const whatsappMessage = `
// Dear ${userData.name},

// 📚 Child Education Planning Summary

// 👶 Child Age: ${childAge} years
// 🎓 Target Education Age: ${educationAge} years

// 💰 Current Education Cost:
// ${formatCurrency(currentEducationCost)}

// 📈 Future Education Cost:
// ${formatCurrency(result.futureCost)}

// 💵 Your Expected Corpus:
// ${formatCurrency(result.futureValueOfSIP)}

// 🎯 Required Monthly SIP:
// ${formatCurrency(
//   result.requiredMonthlySIP.toFixed(0)
// )}

// ${
//   result.isTargetReached
//     ? '✅ Congratulations! You are on track.'
//     : `⚠️ Increase SIP by ${formatCurrency(
//         result.additionalMonthlyNeeded.toFixed(0)
//       )}`
// }

// For personalized financial planning:
// 📞 9726344477

// - Wisdom Consultancy
// `;

//     window.open(
//       `https://wa.me/${
//         userData.phone
//       }?text=${encodeURIComponent(
//         whatsappMessage
//       )}`,
//       '_blank'
//     );
//   };

//   const educationLevels = [
//     {
//       level: 'Graduation',
//       cost: 2000000,
//     },
//     {
//       level: 'MBA',
//       cost: 3500000,
//     },
//     {
//       level: 'Medical',
//       cost: 5000000,
//     },
//     {
//       level: 'Engineering',
//       cost: 2500000,
//     },
//     {
//       level: 'Abroad Study',
//       cost: 8000000,
//     },
//   ];

//   return (
//     <motion.div
//       initial={{
//         opacity: 0,
//         y: 20,
//       }}
//       animate={{
//         opacity: 1,
//         y: 0,
//       }}
//       className="bg-white rounded-[32px] shadow-2xl p-6 md:p-10 border border-[#edf3ff]"
//     >
//       {/* HEADER */}
//       <div className="flex items-center gap-4 mb-8">
//         <div className="w-16 h-16 rounded-2xl bg-[#edf3ff] flex items-center justify-center text-[#2e56b8] text-3xl">
//           <FaGraduationCap />
//         </div>

//         <div>
//           <h3 className="text-3xl font-bold text-[#0b1c39]">
//             Child Education Calculator
//           </h3>

//           <p className="text-gray-600 mt-1">
//             Plan smartly for your child’s future
//             education expenses.
//           </p>
//         </div>
//       </div>

//       <div className="grid lg:grid-cols-2 gap-10">
//         {/* INPUT SECTION */}
//         <div className="space-y-6">
//           {/* Child Age */}
//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-3">
//               Child Current Age
//             </label>

//             <input
//               type="range"
//               min="0"
//               max="17"
//               value={childAge}
//               onChange={(e) =>
//                 setChildAge(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-[#2e56b8]"
//             />

//             <div className="text-center mt-2 font-bold text-[#2e56b8]">
//               {childAge} Years
//             </div>
//           </div>

//           {/* Education Age */}
//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-3">
//               Education Goal Age
//             </label>

//             <input
//               type="range"
//               min={childAge + 1}
//               max="30"
//               value={educationAge}
//               onChange={(e) =>
//                 setEducationAge(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-[#69bf74]"
//             />

//             <div className="text-center mt-2 font-bold text-[#69bf74]">
//               {educationAge} Years
//             </div>
//           </div>

//           {/* Cost */}
//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-3">
//               Current Education Cost
//             </label>

//             <input
//               type="number"
//               value={currentEducationCost}
//               onChange={(e) =>
//                 setCurrentEducationCost(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
//             />

//             <div className="flex flex-wrap gap-2 mt-3">
//               {educationLevels.map(
//                 (item, index) => (
//                   <button
//                     key={index}
//                     onClick={() =>
//                       setCurrentEducationCost(
//                         item.cost
//                       )
//                     }
//                     className="px-3 py-2 bg-[#edf3ff] text-[#2e56b8] rounded-full text-xs font-semibold hover:bg-[#dbe7ff] transition-all"
//                   >
//                     {item.level}
//                   </button>
//                 )
//               )}
//             </div>
//           </div>

//           {/* Inflation */}
//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-3">
//               Education Inflation Rate
//             </label>

//             <input
//               type="range"
//               min="2"
//               max="15"
//               step="0.5"
//               value={inflationRate}
//               onChange={(e) =>
//                 setInflationRate(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-orange-500"
//             />

//             <div className="text-center mt-2 font-bold text-orange-500">
//               {inflationRate}%
//             </div>
//           </div>

//           {/* SIP */}
//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-3">
//               Monthly SIP Investment
//             </label>

//             <input
//               type="number"
//               value={monthlyInvestment}
//               onChange={(e) =>
//                 setMonthlyInvestment(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
//             />
//           </div>

//           {/* Return */}
//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-3">
//               Expected Return
//             </label>

//             <input
//               type="range"
//               min="4"
//               max="20"
//               step="0.5"
//               value={expectedReturn}
//               onChange={(e) =>
//                 setExpectedReturn(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-[#2e56b8]"
//             />

//             <div className="text-center mt-2 font-bold text-[#2e56b8]">
//               {expectedReturn}%
//             </div>
//           </div>

//           {/* BUTTON */}
//           <button
//             onClick={calculate}
//             className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg"
//           >
//             Calculate Education Plan
//           </button>
//         </div>

//         {/* RESULT SECTION */}
//         {result && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             className="bg-gradient-to-br from-[#edf3ff] to-[#f5f7f6] rounded-[30px] p-8"
//           >
//             <div className="flex items-center gap-3 mb-6">
//               <FaBullseye className="text-[#2e56b8] text-2xl" />

//               <h4 className="text-2xl font-bold text-[#0b1c39]">
//                 Education Summary
//               </h4>
//             </div>

//             <div className="space-y-5">
//               <div className="flex justify-between items-center border-b border-gray-200 pb-3">
//                 <span className="text-gray-600">
//                   Future Education Cost
//                 </span>

//                 <span className="font-bold text-[#2e56b8]">
//                   {formatCurrency(
//                     result.futureCost
//                   )}
//                 </span>
//               </div>

//               <div className="flex justify-between items-center border-b border-gray-200 pb-3">
//                 <span className="text-gray-600">
//                   Expected Corpus
//                 </span>

//                 <span className="font-bold text-[#69bf74]">
//                   {formatCurrency(
//                     result.futureValueOfSIP
//                   )}
//                 </span>
//               </div>

//               <div className="flex justify-between items-center border-b border-gray-200 pb-3">
//                 <span className="text-gray-600">
//                   Required SIP
//                 </span>

//                 <span className="font-bold">
//                   {formatCurrency(
//                     result.requiredMonthlySIP.toFixed(
//                       0
//                     )
//                   )}
//                 </span>
//               </div>

//               {/* Progress */}
//               <div className="mt-5">
//                 <div className="flex justify-between text-sm mb-2">
//                   <span>Goal Achievement</span>

//                   <span className="font-semibold">
//                     {result.percentageAchieved.toFixed(
//                       1
//                     )}
//                     %
//                   </span>
//                 </div>

//                 <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
//                   <div
//                     className={`h-full ${
//                       result.isTargetReached
//                         ? 'bg-[#69bf74]'
//                         : 'bg-orange-500'
//                     }`}
//                     style={{
//                       width: `${result.percentageAchieved}%`,
//                     }}
//                   />
//                 </div>
//               </div>

//               <div
//                 className={`mt-6 p-5 rounded-2xl ${
//                   result.isTargetReached
//                     ? 'bg-green-100'
//                     : 'bg-orange-100'
//                 }`}
//               >
//                 <p
//                   className={`font-semibold ${
//                     result.isTargetReached
//                       ? 'text-green-700'
//                       : 'text-orange-700'
//                   }`}
//                 >
//                   {result.isTargetReached
//                     ? '✅ Congratulations! Your education goal is on track.'
//                     : '⚠️ Increase your SIP investment to reach your target.'}
//                 </p>

//                 {!result.isTargetReached && (
//                   <p className="mt-2 text-sm text-gray-700">
//                     Additional SIP Needed:{' '}
//                     <strong>
//                       {formatCurrency(
//                         result.additionalMonthlyNeeded.toFixed(
//                           0
//                         )
//                       )}
//                     </strong>
//                   </p>
//                 )}
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </div>

//       {/* CHART */}
//       {chartData.length > 0 && (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="mt-12"
//         >
//           <div className="flex items-center gap-3 mb-5">
//             <FaChartLine className="text-[#2e56b8] text-2xl" />

//             <h4 className="text-2xl font-bold text-[#0b1c39]">
//               Projection Chart
//             </h4>
//           </div>

//           <div className="bg-[#f8fbff] rounded-[30px] p-5 h-[420px]">
//             <ResponsiveContainer
//               width="100%"
//               height="100%"
//             >
//               <AreaChart data={chartData}>
//                 <defs>
//                   <linearGradient
//                     id="colorSavings"
//                     x1="0"
//                     y1="0"
//                     x2="0"
//                     y2="1"
//                   >
//                     <stop
//                       offset="5%"
//                       stopColor="#69bf74"
//                       stopOpacity={0.8}
//                     />
//                     <stop
//                       offset="95%"
//                       stopColor="#69bf74"
//                       stopOpacity={0}
//                     />
//                   </linearGradient>
//                 </defs>

//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="year" />
//                 <YAxis />
//                 <Tooltip
//                   formatter={(value) =>
//                     formatCurrency(value)
//                   }
//                 />
//                 <Legend />

//                 <Area
//                   type="monotone"
//                   dataKey="savingsAmount"
//                   stroke="#69bf74"
//                   fillOpacity={1}
//                   fill="url(#colorSavings)"
//                   name="Your Savings"
//                 />

//                 <Line
//                   type="monotone"
//                   dataKey="educationCost"
//                   stroke="#2e56b8"
//                   strokeWidth={3}
//                   name="Education Cost"
//                 />
//               </AreaChart>
//             </ResponsiveContainer>
//           </div>
//         </motion.div>
//       )}

//       {/* TIPS */}
//       <div className="mt-10 bg-yellow-50 border border-yellow-200 rounded-[28px] p-6">
//         <h5 className="text-xl font-bold text-yellow-800 mb-4">
//           💡 Education Planning Tips
//         </h5>

//         <ul className="space-y-2 text-yellow-700">
//           <li>
//             • Start investing early to maximize
//             compounding benefits.
//           </li>

//           <li>
//             • Increase SIP annually with salary
//             growth.
//           </li>

//           <li>
//             • Education inflation is usually higher
//             than normal inflation.
//           </li>

//           <li>
//             • Diversify investments based on time
//             horizon.
//           </li>
//         </ul>
//       </div>

//       {/* PDF */}
//       {result && (
//         <div
//           id="education-result-content"
//           style={{ display: 'none' }}
//         >
//           <div
//             style={{
//               padding: '30px',
//               fontFamily: 'Arial',
//             }}
//           >
//             <h1
//               style={{
//                 color: '#1e3c72',
//                 textAlign: 'center',
//               }}
//             >
//               Wisdom Consultancy
//             </h1>

//             <h2
//               style={{
//                 textAlign: 'center',
//               }}
//             >
//               Child Education Planning Report
//             </h2>

//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 marginTop: '20px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td>
//                     Child Age
//                   </td>

//                   <td>
//                     {childAge} Years
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>
//                     Goal Age
//                   </td>

//                   <td>
//                     {educationAge} Years
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>
//                     Future Education Cost
//                   </td>

//                   <td>
//                     {formatCurrency(
//                       result.futureCost
//                     )}
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>
//                     Expected Corpus
//                   </td>

//                   <td>
//                     {formatCurrency(
//                       result.futureValueOfSIP
//                     )}
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>
//                     Required SIP
//                   </td>

//                   <td>
//                     {formatCurrency(
//                       result.requiredMonthlySIP.toFixed(
//                         0
//                       )
//                     )}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {/* BUTTONS */}
//       {result && (
//         <div className="grid md:grid-cols-2 gap-4 mt-8">
//           <button
//             onClick={() => setShowForm(true)}
//             className="flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white py-4 rounded-2xl font-semibold transition-all duration-300"
//           >
//             <FaFilePdf />
//             Download PDF Report
//           </button>

//           <button
//             onClick={() => setShowForm(true)}
//             className="flex items-center justify-center gap-3 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold transition-all duration-300"
//           >
//             <FaWhatsapp />
//             Share on WhatsApp
//           </button>
//         </div>
//       )}

//       {/* FORM */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={handleFormSubmit}
//           onClose={() => setShowForm(false)}
//           calculatorType="Child Education"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default ChildEducationCalculator;

import React, { useState } from 'react';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  AreaChart,
  Area,
} from 'recharts';
import html2pdf from 'html2pdf.js';
import CalculatorForm from './CalculatorForm';
import { motion } from 'framer-motion';
import {
  FaGraduationCap,
  FaChartLine,
  FaBullseye,
  FaFilePdf,
  FaWhatsapp,
  FaUniversity,
  FaChild,
} from 'react-icons/fa';

const ChildEducationCalculator = () => {
  const [childName, setChildName] = useState('');
  const [childAge, setChildAge] = useState(5);
  const [educationAge, setEducationAge] = useState(18);
  const [currentEducationCost, setCurrentEducationCost] =
    useState(1000000);

  const [inflationRate, setInflationRate] =
    useState(10);

  const [monthlyInvestment, setMonthlyInvestment] =
    useState(5000);

  const [stepUpRate, setStepUpRate] = useState(10);

  const [expectedReturn, setExpectedReturn] =
    useState(12);

  const [showForm, setShowForm] = useState(false);
  const [result, setResult] = useState(null);
  const [chartData, setChartData] = useState([]);

  const formatCurrency = (amount) => {
    return `₹${Number(amount).toLocaleString(
      'en-IN'
    )}`;
  };

  const calculate = () => {
    const yearsToEducation =
      educationAge - childAge;

    if (yearsToEducation <= 0) {
      alert(
        'Education age must be greater than child age'
      );
      return;
    }

    const monthlyRate =
      expectedReturn / 12 / 100;

    // FUTURE EDUCATION COST
    const futureCost =
      currentEducationCost *
      Math.pow(
        1 + inflationRate / 100,
        yearsToEducation
      );

    // STEP-UP SIP CALCULATION
    let currentMonthly = monthlyInvestment;
    let futureValue = 0;
    let totalInvestment = 0;

    const data = [];

    for (
      let year = 1;
      year <= yearsToEducation;
      year++
    ) {
      for (let month = 1; month <= 12; month++) {
        futureValue =
          (futureValue + currentMonthly) *
          (1 + monthlyRate);

        totalInvestment += currentMonthly;
      }

      const costAtYear =
        currentEducationCost *
        Math.pow(
          1 + inflationRate / 100,
          year
        );

      data.push({
        year,
        educationCost: Math.round(costAtYear),
        savingsAmount: Math.round(futureValue),
        investedAmount:
          Math.round(totalInvestment),
      });

      currentMonthly =
        currentMonthly *
        (1 + stepUpRate / 100);
    }

    const requiredMonthlySIP =
      (futureCost * monthlyRate) /
      ((Math.pow(
        1 + monthlyRate,
        yearsToEducation * 12
      ) -
        1) *
        (1 + monthlyRate));

    const fundingGap = Math.max(
      0,
      futureCost - futureValue
    );

    const additionalMonthlyNeeded =
      Math.max(
        0,
        requiredMonthlySIP -
          monthlyInvestment
      );

    const isTargetReached =
      futureValue >= futureCost;

    const percentageAchieved =
      (futureValue / futureCost) * 100;

    setResult({
      futureCost,
      futureValue,
      totalInvestment,
      fundingGap,
      additionalMonthlyNeeded,
      requiredMonthlySIP,
      percentageAchieved,
      isTargetReached,
      yearsToEducation,
      finalMonthlySIP: currentMonthly,
    });

    setChartData(data);
  };

  const handleFormSubmit = (userData) => {
    const element = document.getElementById(
      'education-result-content'
    );

    const opt = {
      margin: 0.5,
      filename: `Child_Education_Report_${userData.name}.pdf`,
      image: {
        type: 'jpeg',
        quality: 0.98,
      },
      html2canvas: {
        scale: 2,
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait',
      },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save();

    setShowForm(false);

    const whatsappMessage = `
Dear ${userData.name},

📚 Child Education Planning Summary

👶 Child Name: ${childName || 'Your Child'}

👦 Current Age: ${childAge} Years
🎓 Education Goal Age: ${educationAge} Years

🏫 Current Education Cost:
${formatCurrency(currentEducationCost)}

📈 Future Education Cost:
${formatCurrency(result.futureCost)}

💰 Expected Corpus:
${formatCurrency(result.futureValue)}

💵 Total Investment:
${formatCurrency(result.totalInvestment)}

📊 Required Monthly SIP:
${formatCurrency(
      result.requiredMonthlySIP.toFixed(0)
    )}

📈 Annual Step-Up:
${stepUpRate}%

${
  result.isTargetReached
    ? '✅ Congratulations! Your child education goal is on track.'
    : `⚠️ Additional SIP Needed: ${formatCurrency(
        result.additionalMonthlyNeeded.toFixed(0)
      )}`
}

For personalized investment guidance:

Wisdom Consultancy
📞 9726344477
📧 wisdom2secure@gmail.com
`;

    window.open(
      `https://wa.me/${
        userData.phone
      }?text=${encodeURIComponent(
        whatsappMessage
      )}`,
      '_blank'
    );
  };

  const educationLevels = [
    {
      level: 'Graduation',
      cost: 2000000,
    },
    {
      level: 'Engineering',
      cost: 2500000,
    },
    {
      level: 'MBA',
      cost: 3500000,
    },
    {
      level: 'Medical',
      cost: 5000000,
    },
    {
      level: 'Abroad Study',
      cost: 8000000,
    },
  ];

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 20,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      className="bg-white rounded-[32px] shadow-2xl p-6 md:p-10 border border-[#edf3ff]"
    >
      {/* HEADER */}
      <div className="flex items-center gap-4 mb-8">
        <div className="w-16 h-16 rounded-2xl bg-[#edf3ff] flex items-center justify-center text-[#2e56b8] text-3xl">
          <FaGraduationCap />
        </div>

        <div>
          <h3 className="text-3xl font-bold text-[#0b1c39]">
            Child Education Calculator
          </h3>

          <p className="text-gray-600 mt-1">
            Smart education planning with
            inflation adjusted future cost &
            step-up SIP strategy.
          </p>
        </div>
      </div>

      {/* MAIN GRID */}
      <div className="grid lg:grid-cols-2 gap-10">
        {/* INPUT SECTION */}
        <div className="space-y-6">
          {/* CHILD NAME */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Child Name
            </label>

            <input
              type="text"
              value={childName}
              onChange={(e) =>
                setChildName(e.target.value)
              }
              placeholder="Enter child name"
              className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
            />
          </div>

          {/* CHILD AGE */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Child Current Age
            </label>

            <input
              type="range"
              min="0"
              max="17"
              value={childAge}
              onChange={(e) =>
                setChildAge(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="text-center mt-2 font-bold text-[#2e56b8]">
              {childAge} Years
            </div>
          </div>

          {/* GOAL AGE */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Education Goal Age
            </label>

            <input
              type="range"
              min={childAge + 1}
              max="30"
              value={educationAge}
              onChange={(e) =>
                setEducationAge(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#69bf74]"
            />

            <div className="text-center mt-2 font-bold text-[#69bf74]">
              {educationAge} Years
            </div>
          </div>

          {/* EDUCATION COST */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Current Education Cost
            </label>

            <input
              type="number"
              value={currentEducationCost}
              onChange={(e) =>
                setCurrentEducationCost(
                  Number(e.target.value)
                )
              }
              className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
            />

            <div className="flex flex-wrap gap-2 mt-3">
              {educationLevels.map(
                (item, index) => (
                  <button
                    key={index}
                    onClick={() =>
                      setCurrentEducationCost(
                        item.cost
                      )
                    }
                    className="px-3 py-2 bg-[#edf3ff] text-[#2e56b8] rounded-full text-xs font-semibold hover:bg-[#dbe7ff]"
                  >
                    {item.level}
                  </button>
                )
              )}
            </div>
          </div>

          {/* INFLATION */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Education Inflation Rate
            </label>

            <input
              type="range"
              min="2"
              max="15"
              step="0.5"
              value={inflationRate}
              onChange={(e) =>
                setInflationRate(
                  Number(e.target.value)
                )
              }
              className="w-full accent-orange-500"
            />

            <div className="text-center mt-2 font-bold text-orange-500">
              {inflationRate}%
            </div>
          </div>

          {/* SIP */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Monthly SIP Investment
            </label>

            <input
              type="number"
              value={monthlyInvestment}
              onChange={(e) =>
                setMonthlyInvestment(
                  Number(e.target.value)
                )
              }
              className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
            />
          </div>

          {/* STEP UP */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Annual SIP Step-Up (%)
            </label>

            <input
              type="range"
              min="0"
              max="25"
              step="1"
              value={stepUpRate}
              onChange={(e) =>
                setStepUpRate(
                  Number(e.target.value)
                )
              }
              className="w-full accent-green-500"
            />

            <div className="text-center mt-2 font-bold text-green-600">
              {stepUpRate}% Every Year
            </div>
          </div>

          {/* RETURN */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Expected Return
            </label>

            <input
              type="range"
              min="4"
              max="20"
              step="0.5"
              value={expectedReturn}
              onChange={(e) =>
                setExpectedReturn(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="text-center mt-2 font-bold text-[#2e56b8]">
              {expectedReturn}%
            </div>
          </div>

          {/* BUTTON */}
          <button
            onClick={calculate}
            className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg"
          >
            Calculate Education Plan
          </button>
        </div>

        {/* RESULT */}
        {result && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="bg-gradient-to-br from-[#edf3ff] to-[#f5f7f6] rounded-[30px] p-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <FaBullseye className="text-[#2e56b8] text-2xl" />

              <h4 className="text-2xl font-bold text-[#0b1c39]">
                Education Summary
              </h4>
            </div>

            <div className="space-y-5">
              <div className="flex justify-between border-b pb-3">
                <span>Future Education Cost</span>

                <span className="font-bold text-[#2e56b8]">
                  {formatCurrency(
                    result.futureCost
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span>Expected Corpus</span>

                <span className="font-bold text-green-600">
                  {formatCurrency(
                    result.futureValue
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span>Total Investment</span>

                <span className="font-bold">
                  {formatCurrency(
                    result.totalInvestment
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span>Required SIP</span>

                <span className="font-bold">
                  {formatCurrency(
                    result.requiredMonthlySIP.toFixed(
                      0
                    )
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span>Funding Gap</span>

                <span className="font-bold text-red-600">
                  {formatCurrency(
                    result.fundingGap
                  )}
                </span>
              </div>

              {/* PROGRESS */}
              <div>
                <div className="flex justify-between mb-2 text-sm">
                  <span>Goal Achievement</span>

                  <span className="font-bold">
                    {result.percentageAchieved.toFixed(
                      1
                    )}
                    %
                  </span>
                </div>

                <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className={`h-full ${
                      result.isTargetReached
                        ? 'bg-green-500'
                        : 'bg-orange-500'
                    }`}
                    style={{
                      width: `${Math.min(
                        result.percentageAchieved,
                        100
                      )}%`,
                    }}
                  />
                </div>
              </div>

              {/* STATUS */}
              <div
                className={`p-5 rounded-2xl ${
                  result.isTargetReached
                    ? 'bg-green-100'
                    : 'bg-orange-100'
                }`}
              >
                {result.isTargetReached ? (
                  <p className="font-semibold text-green-700">
                    ✅ Congratulations! Your
                    child education goal is on
                    track.
                  </p>
                ) : (
                  <div>
                    <p className="font-semibold text-orange-700">
                      ⚠ Increase your SIP to
                      achieve your education
                      target.
                    </p>

                    <p className="mt-2">
                      Additional SIP Needed:{' '}
                      <strong>
                        {formatCurrency(
                          result.additionalMonthlyNeeded.toFixed(
                            0
                          )
                        )}
                      </strong>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        )}
      </div>

      {/* CHART */}
      {chartData.length > 0 && (
        <div className="mt-12">
          <div className="flex items-center gap-3 mb-5">
            <FaChartLine className="text-[#2e56b8] text-2xl" />

            <h4 className="text-2xl font-bold text-[#0b1c39]">
              Education Growth Projection
            </h4>
          </div>

          <div className="bg-[#f8fbff] rounded-[30px] p-5 h-[420px]">
            <ResponsiveContainer
              width="100%"
              height="100%"
            >
              <AreaChart data={chartData}>
                <defs>
                  <linearGradient
                    id="colorSavings"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="5%"
                      stopColor="#69bf74"
                      stopOpacity={0.8}
                    />
                    <stop
                      offset="95%"
                      stopColor="#69bf74"
                      stopOpacity={0}
                    />
                  </linearGradient>
                </defs>

                <CartesianGrid strokeDasharray="3 3" />

                <XAxis dataKey="year" />

                <YAxis />

                <Tooltip
                  formatter={(value) =>
                    formatCurrency(value)
                  }
                />

                <Legend />

                <Area
                  type="monotone"
                  dataKey="savingsAmount"
                  stroke="#69bf74"
                  fillOpacity={1}
                  fill="url(#colorSavings)"
                  name="Investment Value"
                />

                <Line
                  type="monotone"
                  dataKey="educationCost"
                  stroke="#2e56b8"
                  strokeWidth={3}
                  name="Education Cost"
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}

      {/* TIPS */}
      <div className="mt-10 bg-yellow-50 border border-yellow-200 rounded-[28px] p-6">
        <h5 className="text-xl font-bold text-yellow-800 mb-4">
          💡 Education Planning Tips
        </h5>

        <ul className="space-y-2 text-yellow-700">
          <li>
            • Start early to maximize
            compounding benefits.
          </li>

          <li>
            • Increase SIP every year with salary
            growth.
          </li>

          <li>
            • Education inflation is higher than
            normal inflation.
          </li>

          <li>
            • Diversify investments for long-term
            goals.
          </li>
        </ul>
      </div>

      {/* PDF */}
      {result && (
        <div
          id="education-result-content"
          style={{ display: 'none' }}
        >
          <div
            style={{
              padding: '30px',
              fontFamily: 'Arial',
            }}
          >
            <h1
              style={{
                color: '#1e3c72',
                textAlign: 'center',
              }}
            >
              Wisdom Consultancy
            </h1>

            <h2
              style={{
                textAlign: 'center',
              }}
            >
              Child Education Planning Report
            </h2>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: '20px',
              }}
            >
              <tbody>
                <tr>
                  <td>Child Name</td>
                  <td>{childName}</td>
                </tr>

                <tr>
                  <td>Child Age</td>
                  <td>{childAge} Years</td>
                </tr>

                <tr>
                  <td>Goal Age</td>
                  <td>{educationAge} Years</td>
                </tr>

                <tr>
                  <td>Future Education Cost</td>

                  <td>
                    {formatCurrency(
                      result.futureCost
                    )}
                  </td>
                </tr>

                <tr>
                  <td>Expected Corpus</td>

                  <td>
                    {formatCurrency(
                      result.futureValue
                    )}
                  </td>
                </tr>

                <tr>
                  <td>Required SIP</td>

                  <td>
                    {formatCurrency(
                      result.requiredMonthlySIP.toFixed(
                        0
                      )
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* BUTTONS */}
      {result && (
        <div className="grid md:grid-cols-2 gap-4 mt-8">
          <button
            onClick={() => setShowForm(true)}
            className="flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white py-4 rounded-2xl font-semibold"
          >
            <FaFilePdf />
            Download PDF Report
          </button>

          <button
            onClick={() => setShowForm(true)}
            className="flex items-center justify-center gap-3 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold"
          >
            <FaWhatsapp />
            Share on WhatsApp
          </button>
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <CalculatorForm
          onSubmit={handleFormSubmit}
          onClose={() => setShowForm(false)}
          calculatorType="Child Education"
          calculationData={{ ...result, chartData }}
          userInputs={{
            childName,
            childAge,
            educationAge,
            currentEducationCost,
            inflationRate,
            monthlyInvestment,
            stepUpRate,
            expectedReturn,
          }}
        />
      )}
    </motion.div>
  );
};

export default ChildEducationCalculator;